/**
 * Employee Web — `/me/hr-letters/$id`: one letter. Letter notifications
 * deep-link here, so non-UUID paths 404 deterministically.
 */
import type { JSX } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { MyLetterDetail } from "@linkhr/employee-self-service";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/_auth/me/hr-letters/$id")({
  staticData: { breadcrumb: { labelKey: "hr-letters:nav.my_letters" } },
  beforeLoad: ({ params }) => {
    if (!UUID_REGEX.test(params.id)) throw notFound();
  },
  component: MeHrLetterDetailRoute,
});

function MeHrLetterDetailRoute(): JSX.Element {
  const { id } = Route.useParams();
  return <MyLetterDetail letterId={id} />;
}
